/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum AreaFullNames {
  sqMeters = 'Meters²',
  sqKilometers = 'Kilometers²',
  sqMiles = 'Miles²',
  acres = 'Acres',
  hectares = 'Hectares',
  sqM = 'Meters²',
  sqKm = 'Kilometers²',
  sqMi = 'Miles²',
  ac = 'Acres',
  ha = 'Hectares',
}

export enum AreaSingularFullName {
  sqMiles = 'Mile²',
  acres = 'Acre',
  hectares = 'Hectare',
  sqMeters = 'Meter²',
  sqKilometers = 'Kilometer²',
}

export enum AreaAbbrevs {
  sqMeters = 'm²',
  sqKilometers = 'km²',
  sqMiles = 'mi²',
  acres = 'ac',
  hectares = 'ha',
  sqM = 'm²',
  sqKm = 'km²',
  sqMi = 'mi²',
  ac = 'ac',
  ha = 'ha',
}

export type SupportedAreaTypes =
  | 'sqMeters'
  | 'sqMiles'
  | 'sqKilometers'
  | 'acres'
  | 'hectares'

export interface AreaConversionFunctions {
  sqMetersToAcres(area: number): number
  sqMetersToHectares(area: number): number
  sqMetersToSqKilometers(area: number): number
  sqMetersToSqMiles(area: number): number
  acresToSqMeters(area: number): number
  acresToHectares(area: number): number
  acresToSqKilometers(area: number): number
  acresToSqMiles(area: number): number
  hectaresToSqMeters(area: number): number
  hectaresToAcres(area: number): number
  hectaresToSqKilometers(area: number): number
  hectaresToSqMiles(area: number): number
  sqKilometersToSqMeters(area: number): number
  sqKilometersToAcres(area: number): number
  sqKilometersToHectares(area: number): number
  sqKilometersToSqMiles(area: number): number
  sqMilesToSqMeters(area: number): number
  sqMilesToAcres(area: number): number
  sqMilesToHectares(area: number): number
  sqMilesToSqKilometers(area: number): number
}
